define([
    "jquery",
    "knockout",
    "helpers/routerHelper",
    "helpers/queryStringHelper",
    "services/documentService",
    "repositories/settingRepository",
    "widgets/pages/documents_add"
], function (jQuery, ko, routerHelper, queryStringHelper, documentService, settingRepository) {
    "use strict";

    var viewModel = (function () {
        var self = null;

        function ctor() {
            self = this;

            //#region Properties
            self.actions = {};
            self.readonly = false;
            self.editId = ko.observable();
            self.dispatchProjectCode = ko.observable();
            //#endregion
        }

        //#region Public Functions
        ctor.prototype.activate = function (params) {
            //var params = routerHelper.getQuerystring(querystring);
            self.readonly = queryStringHelper.parseReadonly(params.q);
            self.editId(params.recommendationId);
            self.dispatchProjectCode(params.dispatchProjectCode);

            var dispatchTemplateId = settingRepository.getDispatchTemplate();

            self.actions = {
                save: documentService.saveRecommendationPicture.bind(self, params.recommendationId, 'project', params.dispatchProjectCode, dispatchTemplateId)
            };
        };
        //#endregion
        return ctor;
    })();

    return viewModel;
});
